import moment from 'moment'

/**
 * Calendar dates (date of birth) with no time zone shift, on moment.
 *
 * Rows hold a date of birth as "YYYY-MM-DD", or as an older UTC ISO timestamp
 * ("1994-02-14T00:00:00.000Z"). `new Date("1994-02-14")` is UTC midnight,
 * which is the evening before in US time zones, so a date picker showed the
 * day before. Here the stored text is read in UTC (its calendar day), the
 * picker gets local midnight on that day, and the day goes back as "YYYY-MM-DD".
 */

const YMD = 'YYYY-MM-DD'
// What a stored value can look like; strict, so other text is unreadable.
const STORED_FORMATS = [moment.ISO_8601, 'MM/DD/YYYY']

/** "YYYY-MM-DD" of a value (stored text read in UTC; a picked Date by its local day); '' when none. */
export const toYmd = (value) => {
    if (value === null || value === undefined || String(value).trim() === '') return ''
    const m = value instanceof Date ? moment(value) : moment.utc(String(value).trim(), STORED_FORMATS, true)
    return m.isValid() ? m.format(YMD) : ''
}

/** A Date at local midnight on the value's calendar day, or null. */
export const toLocalDate = (value) => {
    const ymd = toYmd(value)
    return ymd ? moment(ymd, YMD, true).toDate() : null
}

/** "MM/DD/YYYY" of the value's calendar day, or ''. */
export const toUsDate = (value) => {
    const ymd = toYmd(value)
    return ymd ? moment(ymd, YMD).format('MM/DD/YYYY') : ''
}
